<template>
  <b-dropdown
    :text="filter_is_active_label"
    variant="dropdown-curve"
    class="ml-auto mr-3 filter-status-dropdown"
  >
    <b-dropdown-item @click="onChangeFilterIsActive('Approve')">
      Approve
    </b-dropdown-item>

    <b-dropdown-item @click="onChangeFilterIsActive('Pending')">
      Pending
    </b-dropdown-item>

    <b-dropdown-item @click="onChangeFilterIsActive('Reject')">
      Reject
    </b-dropdown-item>

    <b-dropdown-item @click="onChangeFilterIsActive('All')">
      All
    </b-dropdown-item>
  </b-dropdown>
</template>
<script>
import { EventBus } from "@/main";

export default {
  name: "FilterByStatusDropdown2",
  props: {
    onSelect: {
      type: Function,
      default: this.onChangeFilterIsActive
    },
  },
  data() {
    return {
      filter_is_active_label: "All",
      filterIsActive: "AP"
    };
  },
  beforeMount() {
    EventBus.$on("STATUS_CHANGE", data => {
      console.log(data, "STATUS_CHANGE");
      this.onChangeFilterIsActiveStatus(data);
    });
  },
  methods: {
    onChangeFilterIsActive(option) {
      this.filter_is_active_label = option;
      switch (option.toLowerCase()) {
        case "approve":
          this.filterIsActive = "AP";
          break;
        case "pending":
          this.filterIsActive = "P";
          break;
        case "all":
          this.filterIsActive = "ALL";
          break;
        case "reject":
          this.filterIsActive = "R";
          break;
        default:
          this.filterIsActive = null;
          break;
      }
      this.onSelect && this.onSelect(this.filterIsActive);
    },
    onChangeFilterIsActiveStatus(option) {
      this.filterIsActive = option;
      switch (option.toLowerCase()) {
        case "ap":
          this.filter_is_active_label = "Approve";
          break;
        case "p":
          this.filter_is_active_label = "Pending";
          break;
        case "all":
          this.filter_is_active_label = "All";
          break;
        case "reject":
          this.filter_is_active_label = "Reject";
          break;
        default:
          this.filter_is_active_label = null;
          break;
      }
    }
  }
};
</script>
<style>
.filter-status-dropdown button {
  padding-right: 28px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/FilterByStatusDropdown2.vue